import { useEffect, useRef } from "react";
import { motion, useMotionValue, useSpring, useTransform, useInView } from "framer-motion";

// Spring-tweens a number between values. Pass `triggerOnView` for a
// count-up-once-visible stat; omit it for a value that should keep
// re-tweening whenever `value` changes (e.g. an interactive calculator).
export default function AnimatedNumber({
  value,
  format = (n) => Math.round(n).toLocaleString(),
  className,
  triggerOnView = false,
  ...rest
}) {
  const motionValue = useMotionValue(triggerOnView ? 0 : value);
  const spring = useSpring(motionValue, { stiffness: 100, damping: 24, mass: 0.6 });
  const display = useTransform(spring, format);
  const ref = useRef(null);
  const inView = useInView(ref, { once: true, margin: "-80px" });

  useEffect(() => {
    if (!triggerOnView || inView) motionValue.set(value);
  }, [value, inView, triggerOnView, motionValue]);

  return (
    <motion.span ref={ref} className={className} {...rest}>
      {display}
    </motion.span>
  );
}
